export enum StudentRoutes {
  HOME = '/student',
  CHOOSE_CLASS = '/student/choose-class',
  CHOOSE_PROGRAM = '/student/choose-program',
  PROGRAM = '/student/program',
  NO_LICENSES = '/student/no-licenses',
}
